import { Container, TabContainer, TabItem } from "./NoshowPolicyManagementPage.styles";
import UI from "@mile-meeting/mile-ui";
import NoshowPolicySettingTab from "./NoshowPolicySettingTab/NoshowPolicySettingTab";
import React, { useEffect, useState } from "react";
import { TSearchPeriod } from "./NoshowReservationManagementTab/types";
import NoshowReservationManagementTab from "./NoshowReservationManagementTab/NoshowReservationManagementTab";
import NoshowReservationDetail from "./NoshowReservationDetail";
import { useLocation } from "react-router-dom";

const RoomPolicy = () => {
  const [tab, setTab] = React.useState<"노쇼 기능 설정" | "노쇼 예약 관리" | "노쇼 예약 상세보기">("노쇼 기능 설정");
  const id = useLocation().search.split("=")[1]; // URL에서 id 파라미터 추출
  const oneMonthAgo = new Date();
  oneMonthAgo.setMonth(oneMonthAgo.getMonth() - 3);

  const [period, setPeriod] = useState<TSearchPeriod>({
    startDate: oneMonthAgo,
    endDate: new Date(),
  }); //* INFO : 조회 기간

  useEffect(() => {
    if (id) setTab("노쇼 예약 상세보기");
  }, []);

  return (
    <Container style={{ minWidth: 1140, boxSizing: "border-box", position: "relative" }}>
      <UI.Typography
        type="title03"
        fontStyle="bold"
        color="var(--alias-color-label-neutral)"
        style={{ padding: "24px 20px" }}
      >
        노쇼 정책 관리
      </UI.Typography>
      <TabContainer style={{ marginTop: "8px" }}>
        <TabItem selected={tab === "노쇼 기능 설정"} onClick={() => setTab("노쇼 기능 설정")}>
          <UI.Typography
            type="body01 normal"
            fontStyle="bold"
            color={
              tab === "노쇼 기능 설정" ? "var(--alias-color-primary-normal" : "var(--alias-color-label-alternative)"
            }
          >
            노쇼 기능 설정
          </UI.Typography>
        </TabItem>
        <TabItem selected={tab === "노쇼 예약 관리"} onClick={() => setTab("노쇼 예약 관리")}>
          <UI.Typography
            type="body01 normal"
            fontStyle="bold"
            color={
              tab === "노쇼 예약 관리" ? "var(--alias-color-primary-normal" : "var(--alias-color-label-alternative)"
            }
          >
            노쇼 예약 관리
          </UI.Typography>
        </TabItem>
      </TabContainer>
      <NoshowPolicySettingTab isShow={tab === "노쇼 기능 설정"} />
      <NoshowReservationManagementTab
        period={period}
        setPeriod={setPeriod}
        hide={tab === "노쇼 예약 관리" ? false : true}
      />
      {id && <NoshowReservationDetail period={period} id={id} />}
    </Container>
  );
};

export default RoomPolicy;
